import { generateClassName } from '@klv/shared/utils/functions';

import { List } from '../list';

import * as gridStyles from '@klv/utils/grid/styles/grid.module.css';
import * as styles from './styles/drawer.module.css';

import type { IUniversalMenuItemWithCustomFields } from '@klaviyo-mkt/gatsby-source-universal-navigation/src/types';


export const UniversalNavigationDrawer = ({
  className,
  menuStyle = 'default',
  menuItems = [],
  parentLabel,
}: {
  className?: string;
  menuItems?: IUniversalMenuItemWithCustomFields[];
  menuStyle?: 'default' | 'drilldown' | 'subnav';
  parentLabel?: string;
}) => {
  if (menuItems.length === 0) return;
  const upperItems = menuItems.filter(({ position }) => position === 'upper');
  const lowerItems = menuItems.filter(({ position }) => position === 'lower');

  return (
    <div className={generateClassName([className, styles.drawer, menuStyle === 'drilldown' && styles.drilldown, menuStyle === 'subnav' && styles.subnav])}>
      <div className={generateClassName([styles.content])}>
        <ul className={generateClassName([gridStyles.grid, styles.list])}>
          {upperItems.map(({ id, ...rest }) => (
            <List className={styles.column} id={id} key={id} menuStyle={menuStyle === 'subnav' ? 'default' : menuStyle} parentLabel={parentLabel} {...rest} />
          ))}
        </ul>
        {(lowerItems.length > 0) && (
          <ul className={generateClassName([gridStyles.grid, styles.list, styles.lower])}>
            {lowerItems.map(({ id, ...rest }) => (
              <List className={generateClassName([styles.column])} id={id} key={id} menuStyle={menuStyle === 'subnav' ? 'default' : menuStyle} parentLabel={parentLabel} drawerPosition='lower' {...rest} />
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
